module.exports = __webpack_public_path__ + "img/XiaohongshuQRcode.30291769.jpeg";